/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/prescriptions-list';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 360,
        padding: 0,
    },
    columnWidth: {
        orderNumber: 190,
        orderDate: 116,
        orderAmount: 170,
        orderStatus: 170,
        trackingNumber: 210,
        drugName: 190,
        rxNumber: 116,
        paid: 170,
        status: 170,
        queue: 210,

        // special columns
        _selectionActions: 16, // checkbox selection
        _headActions: 210,
        _groupActions: 210
    },
    filterFlyoutWidths: {
        rxNumber: 180,
        status: 300
    },
    valueColors: {},
    actionIcons: {
        editOrder: 'edit',
        toDos: 'checkedContent',
        lineItemToDo: 'checkedContent',
        orderToDo: 'checkedContent',
        cancelOrder: 'cancelOrder',
        markResolved: 'checkedCircle',
        reorder: 'reorder',
        checkout: 'cart',
        viewMoreAction: 'viewMore',
        fetchRxNotes: 'checkedContent',
        rxMarkResolved: 'checkedCircle',
        notes: 'callNotes',
        orderNotes: 'callNotes',
        orderDate: 'info'
    },
    columnIcons: {
        drugName: {
            name: 'info',
            path: 'values.drugNameInfo'
        }
    }
};

